// 格式化码流（bitrate 通常以 bps 为单位）
export const formatBitrate = (bitrate, unknownLabel = '-') => {
  if (!bitrate) return unknownLabel;
  // music-metadata 返回的 bitrate 是以 bps (bits per second) 为单位
  // 需要转换为 kbps 或 Mbps
  if (bitrate >= 1000000) {
    // >= 1 Mbps
    return `${(bitrate / 1000000).toFixed(1)} Mbps`;
  } else if (bitrate >= 1000) {
    // >= 1 kbps
    return `${(bitrate / 1000).toFixed(0)} kbps`;
  }
  return `${bitrate} bps`;
};

// 格式化采样率
export const formatSampleRate = (sampleRate, unknownLabel = '-') => {
  if (!sampleRate) return unknownLabel;
  if (sampleRate >= 1000) {
    return `${(sampleRate / 1000).toFixed(1)} kHz`;
  }
  return `${sampleRate} Hz`;
};

// 格式化文件大小（用于信息弹窗等）
export const formatFileSize = (bytes, unknownLabel = '-') => {
  if (!bytes || bytes === 0) return unknownLabel;
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

